// extracted by mini-css-extract-plugin
export default {"div":"Footer_div__LosjT","filler":"Footer_filler__zbl5w"};